function makeCtx() {
  const Ctx = window.AudioContext || window.webkitAudioContext;
  if (!Ctx) return null;
  return new Ctx();
}

export async function playShortErrorBeep() {
  try {
    const Ctx = window.AudioContext || window.webkitAudioContext;
    if (!Ctx) return;

    const ctx = new Ctx();

    if (ctx.state === "suspended") {
      await ctx.resume();
    }

    const now = ctx.currentTime;

    function beep(start, freq) {
      const osc = ctx.createOscillator();
      const gain = ctx.createGain();

      osc.type = "square"; // blijft duidelijk, maar zwaarder door lage freq
      osc.frequency.setValueAtTime(freq, start);

      gain.gain.setValueAtTime(0.0001, start);
      gain.gain.linearRampToValueAtTime(0.25, start + 0.01);
      gain.gain.exponentialRampToValueAtTime(0.0001, start + 0.22);

      osc.connect(gain);
      gain.connect(ctx.destination);

      osc.start(start);
      osc.stop(start + 0.22);
    }

    // 🔻 lagere frequentie = zwaarder
    beep(now, 380);
    beep(now + 0.14, 380);

    setTimeout(() => {
      ctx.close().catch(() => {});
    }, 500);

  } catch {}
}
export async function playErrorBeep() {
  try {
    const ctx = makeCtx();
    if (!ctx) return;

    if (ctx.state === "suspended") {
      await ctx.resume();
    }

    const osc = ctx.createOscillator();
    const gain = ctx.createGain();

    osc.type = "square";
    gain.gain.setValueAtTime(0.3, ctx.currentTime);

    osc.connect(gain);
    gain.connect(ctx.destination);

    const start = ctx.currentTime;
    const duration = 6;   // iets korter dan 10 sec, maar nog steeds duidelijk lang
    const cycle = 0.20;

    let t = start;
    while (t < start + duration) {
      osc.frequency.setValueAtTime(480, t);
      t += cycle / 2;
      osc.frequency.setValueAtTime(680, t);
      t += cycle / 2;
    }

    osc.start(start);
    osc.stop(start + duration);

    osc.onended = () => {
      ctx.close().catch(() => {});
    };
  } catch {}
}

export async function playSuccessBeep() {
  try {
    const Ctx = window.AudioContext || window.webkitAudioContext;
    if (!Ctx) return;

    const ctx = new Ctx();

    if (ctx.state === "suspended") {
      await ctx.resume();
    }

    const now = ctx.currentTime;

    // 🔔 hoofd toon
    const osc1 = ctx.createOscillator();
    const gain1 = ctx.createGain();

    osc1.type = "sine";
    osc1.frequency.setValueAtTime(880, now);

    gain1.gain.setValueAtTime(0.0001, now);
    gain1.gain.linearRampToValueAtTime(0.18, now + 0.01);
    gain1.gain.exponentialRampToValueAtTime(0.0001, now + 0.9);

    osc1.connect(gain1);
    gain1.connect(ctx.destination);

    osc1.start(now);
    osc1.stop(now + 0.9);

    // 🔔 harmonische toon (maakt het “belachtig”)
    const osc2 = ctx.createOscillator();
    const gain2 = ctx.createGain();

    osc2.type = "sine";
    osc2.frequency.setValueAtTime(1320, now);

    gain2.gain.setValueAtTime(0.0001, now);
    gain2.gain.linearRampToValueAtTime(0.12, now + 0.02);
    gain2.gain.exponentialRampToValueAtTime(0.0001, now + 0.7);

    osc2.connect(gain2);
    gain2.connect(ctx.destination);

    osc2.start(now);
    osc2.stop(now + 0.7);

    // 🔔 kleine echo (maakt het echt “pling”)
    const osc3 = ctx.createOscillator();
    const gain3 = ctx.createGain();

    osc3.type = "sine";
    osc3.frequency.setValueAtTime(1000, now + 0.15);

    gain3.gain.setValueAtTime(0.0001, now + 0.15);
    gain3.gain.linearRampToValueAtTime(0.08, now + 0.17);
    gain3.gain.exponentialRampToValueAtTime(0.0001, now + 0.6);

    osc3.connect(gain3);
    gain3.connect(ctx.destination);

    osc3.start(now + 0.15);
    osc3.stop(now + 0.6);

    // netjes afsluiten
    setTimeout(() => {
      ctx.close().catch(() => {});
    }, 1000);

  } catch {}
}